import Select from './Select';
import RoleTree from './RoleTree';
import Employee from './Employee';
import Modal from './Modal';
import StudentRoleModal from './StudentRoleModal';
import StudentModal from './StudentModal';
import MasterModal from './MasterModal';
import MasterRoleModal from './MasterRoleModal';
//account
export default {
    Select,
    RoleTree,
    Employee,
    Modal,
    StudentRoleModal,
    StudentModal,
    MasterModal,
    MasterRoleModal
}